import { action } from '@ember/object';
import Service, { service } from '@ember/service';
import nameSort from 'scaleflow/utils/nameSort';
// import { tracked } from '@glimmer/tracking';

export default class InitiativesService extends Service {
  @service store;
  fetched = false;
  results = [];

  /**
   *
   * @returns {Object} id, value, abbv, title
   */
  async getInitiatives() {
    if (!this.fetched) {
      return await this.loadInitiatives();
    } else {
      return this.convertToValueLabel(this.store.peekAll('initiative'));
    }
  }

  getInitiativesSync() {
    return this.store
      .peekAll('initiative')
      .slice()
      .sort((a, b) => nameSort(a.title, b.title));
  }

  convertToValueLabel(array) {
    return array.map((item) => {
      return {
        id: item.id,
        value:
          item.abbreviation && item.abbreviation.length !== 0
            ? item.abbreviation
            : item.title,
        abbv:
          item.abbreviation && item.abbreviation.length !== 0
            ? item.abbreviation
            : '',
        title: item.title,
      };
    });
  }

  @action
  async loadInitiatives() {
    const initiatives = this.convertToValueLabel(
      (await this.store.query('initiative', {}))
        .slice()
        .sort((a, b) => nameSort(a.title, b.title)),
    );
    this.fetched = true;
    // this.results = initiatives;
    return initiatives;
  }
}
